import axios from "axios";

export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const eventsApi = axios.create({
  baseURL: `${BACKEND_URL}/api`,
  timeout: 15000,
  withCredentials: true,
  headers: { "X-Request-ID": `web_${Date.now().toString(36)}` },
});

export const eventFileUrl = (path) => path ? `${BACKEND_URL}${path}` : "";
